// Pemetaan awalan path → id menu (sinkron dengan MENU_CATALOG backend & ALL_LINKS Layout)
export const MENU_BY_PATH = [
  ["/jemaat/terhapus", "jemaat-terhapus"],
  ["/jemaat", "jemaat"],
  ["/household", "household"],
  ["/keluarga", "keluarga-list"],
  ["/presensi/rekap-pelayan", "jadwal-pelayanan"],
  ["/presensi", "presensi"],
  ["/jadwal-pelayanan", "jadwal-pelayanan"],
  ["/ulang-tahun", "ulang-tahun"],
  ["/pengajuan-pelayanan", "pengajuan"],
  ["/kegiatan", "kegiatan"],
  ["/care-leader", "care-leader-list"],
  ["/kondisi-anggota", "kondisi-anggota"],
  ["/kunjungan/daftar", "kunjungan-daftar"],
  ["/kunjungan", "kunjungan"],
  ["/struktur-organisasi", "struktur"],
  ["/pengumuman", "pengumuman"],
  ["/users", "users"],
  ["/audit-log", "audit"],
  ["/pengaturan/backup", "export-backup"],
  ["/data-anak", "data-anak"],
  ["/pengaturan", "pengaturan"],
];
export const menuIdForPath = (pathname) => {
  if (pathname === "/") return "dashboard";
  const hit = MENU_BY_PATH.find(([p]) => pathname === p || pathname.startsWith(p + "/"));
  return hit ? hit[1] : null;
};
